import React from 'react'
import { FileBrowserProvider, type FileBrowserProviderProps } from './Context'
import { Stack } from 'react-bootstrap'
import { Toolbox } from './Toolbox'
import { FileList } from './FileList'

export type FileBrowserProps = Omit<FileBrowserProviderProps, 'children'>

export const FileBrowser = (props: FileBrowserProps) => {
  return (
    <FileBrowserProvider {...props}>
      <Layout />
    </FileBrowserProvider>
  )
}

const Layout = () => {
  return (
    <Stack gap={1}>
      <Stack gap={2}>
        <Toolbox />
        <FileList />
      </Stack>
    </Stack>
  )
}
